<script lang="ts">
	import { Container } from '$lib/components/ui/container';
	import { onMount } from 'svelte';

	let activeExampleId: number = 0;
	let promptExample: string = '';

	const examples = [
		{
			prompt: 'Which build is best for Akali?',
			response: ''
		},
		{
			prompt: 'Can you give me a tier list for ADCs?',
			response: ''
		},
		{
			prompt: 'Akali vs Sylas VODs',
			response: ''
		}
	];

	const nextExample = () => {
		activeExampleId = (activeExampleId + 1) % examples.length;
		animatePromptExample();
	};

	const animatePromptExample = () => {
		const text = examples[activeExampleId].prompt;
		const textArray = text.split('');
		promptExample = '';

		textArray.forEach((letter, i) => {
			setTimeout(() => {
				promptExample += letter;
			}, 25 * i);
		});

		setTimeout(() => {
			nextExample();
		}, 3000);
	};

	onMount(() => {
		animatePromptExample();
	});
</script>

<Container class="pb-8 pt-4 sm:pt-8">
	<enhanced:img
		src="/static/images/star_full.png"
		alt="img"
		class="absolute right-[200px] top-[300px] h-4 w-4"
	/>
	<enhanced:img
		src="/static/images/star_full.png"
		alt="img"
		class={`absolute right-[300px] top-[700px] h-5 w-5`}
	/>
	<enhanced:img
		src="/static/images/star_full.png"
		alt="img"
		class={`absolute left-[300px] top-[600px] h-4 w-4`}
	/>
	<enhanced:img
		src="/static/images/star_full.png"
		alt="img"
		class="absolute left-[130px] top-[200px] h-3 w-3"
	/>
	<div class="bg-spotlight -top-20 mx-auto max-h-[500px] max-w-[500px]" />
	<div class="bg-hero-lines-pattern top-0 max-h-[400px] max-w-[1100px]" />
	<div class="mx-auto flex h-auto w-full flex-col items-center justify-center">
		<h1 class="sm:text-6-xl mt-16 max-w-5xl text-center text-5xl lg:text-7xl">
			Dominate with <span class="relative whitespace-nowrap text-primary"> Meeko </span><br />Your
			League of Legends AI
		</h1>
		<div
			class="relative mt-12 hidden h-16 w-full max-w-xl items-center justify-between rounded-full border border-darkQuaternary bg-darkTertiary pl-6 pr-2 sm:flex"
		>
			<span class="block w-full select-none text-base font-light text-lightSecondary"
				>{promptExample}</span
			>
		</div>
		<div class="flex w-full flex-col items-center justify-center gap-3 sm:hidden">
			<div
				class="relative mt-12 flex h-16 w-full max-w-xl items-center justify-between rounded-full border border-darkQuaternary bg-darkTertiary pl-6 pr-2"
			>
				<span class="select-none text-base font-light text-lightSecondary">{promptExample}</span>
			</div>
		</div>
		<p class="mt-8 max-w-xl px-2 text-center font-light text-lightSecondary">
			Receive personalized coaching, draft suggestions, matchup advice and more.{' '}<br
				class="hidden sm:block"
			/>Available 24/7 on Discord, Windows and macOS.
		</p>
	</div>
</Container>
